import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerLeftUp"><Path fillRule="evenodd" clipRule="evenodd" d="M20.4142 19.4142H10.4142V6.82843L13.4142 9.82843L14.8284 8.41421L9.41421 3L4 8.41421L5.41421 9.82843L8.41421 6.82843V21.4142H20.4142V19.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerLeftUp;
